module.exports = __webpack_public_path__ + "img/reportforrepair2.98479b97.png";